module.exports = __webpack_public_path__ + "static/media/cloud.5394901b.svg";